import { render } from "./EmailPanel.vue?vue&type=template&id=0a68ea55&scoped=true"
import script from "./EmailPanel.vue?vue&type=script&lang=js"
export * from "./EmailPanel.vue?vue&type=script&lang=js"

import "./EmailPanel.vue?vue&type=style&index=0&id=0a68ea55&lang=scss&scoped=true"
import "./EmailPanel.vue?vue&type=style&index=1&id=0a68ea55&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a68ea55"]])

export default __exports__